import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  labelStyles: {
    textTransform: "lowercase",
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.gray80.main,
    borderTopLeftRadius: "2px",
    borderTopRightRadius: "2px",
    padding: "0px 10px",
  },
}));

export default useStyles;
